var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 19,
    viewBox: "0 0 31 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 31,
    height: 18,
    rx: 2,
    fill: "#31F8C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3008 4.96875L9.81836 13.5H8.32422L6.66602 7.59961L5.64062 13.5H4.11133L5.58203 4.96875H7.08203L8.74609 10.875L9.77148 4.96875H11.3008ZM16.3699 12.1934L16.1414 13.5H12.5437L12.7664 12.1934H16.3699ZM14.4656 4.96875L12.9891 13.5H11.4598L12.9305 4.96875H14.4656ZM16.534 8.47266L16.3113 9.74414H13.1941L13.4109 8.47266H16.534ZM17.6004 4.96875L17.3719 6.28125H13.7918L14.0203 4.96875H17.6004ZM19.4293 11.8594L21.8141 4.96875H22.6754L22.5758 6.43945L20.0504 13.5H19.1305L19.4293 11.8594ZM19.857 4.96875L19.8336 11.9824L19.5348 13.5H18.5562L18.3629 4.96875H19.857ZM22.9332 11.8125L25.0426 4.96875H26.5836L23.7359 13.5H22.7398L22.9332 11.8125ZM23.0914 4.96875L23.3258 12.0176L23.1266 13.5H22.2301L21.9312 6.28711L22.2477 4.96875H23.0914Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.813797b50cc7b242c7d1c6dc03c58d84.svg";
export { ForwardRef as ReactComponent };